module.exports = __webpack_public_path__ + "static/media/eagle.f0a8104c.png";